export default {
    TRAINEE: 0,
    APPRENTICESHIP: 1,
    CONSULTANT: 2,
    ASSISTANCE: 3,
    CEO: 4
}
